::ng-deep .title-header{margin:0;font-size:.9rem;font-weight:500;padding:10px;border:1px solid rgba(0,0,0,.1);background:var(--surface-sunken, #f1f2f3)}::ng-deep .title-header .particle-dynamic-html ul{list-style-type:disc}
/*# sourceMappingURL=treaty-summary.component-NJY3ZEJN.css.map */
